import AjaxService from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchCalendars = (provider, { offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: `${provider}/calendars`,
        params: {
            offset,
            limit
        }
    })
    .then(response => {
        if (provider === 'microsoft') {
            return {
                items: (response.data?.value || []).map(item => ({
                    ...item,
                    provider
                }))
            }
        }

        return {
            ...response.data,
            items: (response.data?.items || []).map(item => ({
                ...item,
                name: item.summary,
                provider
            }))
        };
    })
    .catch(handleServerError);
}

export const fetchCalendar = (provider, calendarId) => {
    return AjaxService({
        method: 'get',
        url: `${provider}/calendars/${calendarId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const watchCalendar = (provider, calendarId) => {
    return AjaxService({
        method: 'post',
        url: `${provider}/calendars/${calendarId}/watch`
    })
    .then(response => response.data)
    .catch(error => handleServerError(error, {
        silent: true
    }));
}

export const unwatchCalendar = (provider, calendarId) => {
    return AjaxService({
        method: 'delete',
        url: `${provider}/calendars/${calendarId}/watch`
    })
    .then(response => response.data)
    .catch(error => handleServerError(error, {
        silent: true
    }));
}

export const createEvent = (provider, calendarId, { start, end, summary, description }) => {
    return AjaxService({
        method: 'post',
        url: `${provider}/calendars/${calendarId}/events`,
        data: {
            start,
            end,
            summary,
            description
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchEvents = (provider, calendarId, { pageToken }) => {
    return AjaxService({
        method: 'get',
        url: `${provider}/calendars/${calendarId}/events`,
        params: {
            pageToken
        }
    })
    .then(response => {
        if (provider === 'microsoft') {
            return {
                items: (response.data?.value || []).map(item => ({
                    ...item,
                    name: item.subject,
                    provider
                }))
            }
        }

        return {
            ...response.data,
            items: (response.data?.items || []).map(item => ({
                ...item,
                name: item.summary,
                provider
            }))
        };
    })
    .catch(handleServerError);
}

export const updateEvent = (provider, calendarId, eventId, { start, end, summary, description }) => {
    return AjaxService({
        method: 'put',
        url: `${provider}/calendars/${calendarId}/events/${eventId}`,
        data: {
            start,
            end,
            summary,
            description
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeEvent = (provider, calendarId, eventId) => {
    return AjaxService({
        method: 'delete',
        url: `${provider}/calendars/${calendarId}/events/${eventId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
